import type { z } from 'zod';
import {
  deserializeActionData,
  isSerializedActionPayload,
  type SerializedActionPayload,
} from '@/lib/actions/serialization';
import {
  ProfileResponseSchema,
  ProfileSearchResponseSchema,
  ReplyNetworkResponseSchema,
  SearchResponseSchema,
  UserInsightsResponseSchema,
} from './schemas';

export type ProfileResponseInput = z.input<typeof ProfileResponseSchema>;
export type ProfileResponseOutput = z.output<typeof ProfileResponseSchema>;
export type ProfileResponsePayload = ProfileResponseInput | SerializedActionPayload;

export function normalizeProfileResponsePayload(payload: ProfileResponsePayload): ProfileResponseInput {
  // Profile responses can cross the RSC/safe-action transport wrapped in devalue; decode
  // once here so downstream callers keep working with real objects/dates.
  if (isSerializedActionPayload(payload)) {
    return deserializeActionData<ProfileResponseInput>(payload);
  }
  return payload;
}

export function parseProfileResponsePayload(payload: ProfileResponsePayload): ProfileResponseOutput {
  return ProfileResponseSchema.parse(normalizeProfileResponsePayload(payload));
}

export function serializeProfileResponse(payload: ProfileResponseInput): ProfileResponseOutput {
  return ProfileResponseSchema.parse(payload);
}

export type ProfileSearchResponseInput = z.input<typeof ProfileSearchResponseSchema>;
export type ProfileSearchResponseOutput = z.output<typeof ProfileSearchResponseSchema>;

export function serializeProfileSearchResponse(payload: ProfileSearchResponseInput): ProfileSearchResponseOutput {
  return ProfileSearchResponseSchema.parse(payload);
}

export type SearchResponseInput = z.input<typeof SearchResponseSchema>;
export type SearchResponseOutput = z.output<typeof SearchResponseSchema>;

export function serializeSearchResponse(payload: SearchResponseInput): SearchResponseOutput {
  return SearchResponseSchema.parse(payload);
}

export type ReplyNetworkResponseInput = z.input<typeof ReplyNetworkResponseSchema>;
export type ReplyNetworkResponseOutput = z.output<typeof ReplyNetworkResponseSchema>;

export function serializeReplyNetworkResponse(payload: ReplyNetworkResponseInput): ReplyNetworkResponseOutput {
  return ReplyNetworkResponseSchema.parse(payload);
}

export type UserInsightsResponseInput = z.input<typeof UserInsightsResponseSchema>;
export type UserInsightsResponseOutput = z.output<typeof UserInsightsResponseSchema>;

export function serializeUserInsightsResponse(payload: UserInsightsResponseInput): UserInsightsResponseOutput {
  return UserInsightsResponseSchema.parse(payload);
}
